import * as endpoints from './../constants/api-constants'
import { axiosInstance } from './axios-instance'

class AuthService {
  static authentication(payload) {
    return axiosInstance
      .post(endpoints.authentication, payload)
      .then(resp => resp.data)
  }
  static recoveryPass(mailOrPhone, option) {
    var payload = {
      optionRecovery: option,
      mailOrPhone:
        option === 'sms'
          ? process.env.COUNTRY_PHONE_PREFIX + mailOrPhone
          : mailOrPhone,
    }
    return axiosInstance
      .post(endpoints.recoverPass, payload)
      .then(resp => resp.data)
  }
  static restorePass(payload, config) {
    return axiosInstance
      .post(endpoints.restorePass, payload, config)
      .then(resp => resp.data)
  }
  static restorePassToken(payload, config) {
    return axiosInstance
      .post(endpoints.restorePassToken, payload, config)
      .then(resp => resp.data)
  }
  static stateUser(payload) {
    return axiosInstance
      .get(endpoints.stateUser + payload)
      .then(resp => resp.data)
  }
  static sessionInfo(config) {
    return axiosInstance
      .get(endpoints.accountInfo, config)
      .then(resp => resp.data)
  }
  static updateAccount(payload, config) {
    return axiosInstance
      .put(endpoints.accountUpdate, payload, config)
      .then(resp => resp.data)
  }
  static updatePicture(payload, config) {
    return axiosInstance
      .post(endpoints.pictureUpdate, payload, config)
      .then(resp => resp.data)
  }
  static sendOTP(value, config) {
    var payload = {
      value,
    }
    return axiosInstance
      .post(endpoints.otpSend, payload, config)
      .then(resp => resp.data)
  }
  static validateOTP(value, config) {
    var payload = {
      value,
    }
    return axiosInstance
      .post(endpoints.otpValidate, payload, config)
      .then(resp => resp.data)
  }

  static validateUpdateAccount(payload, config) {
    return axiosInstance
      .post(endpoints.accountUpdate, payload, config)
      .then(resp => resp.data)
  }
}

export default AuthService
